import { Stack } from '@mui/material';
import { Close } from '@ucr/icons/main';

import {
  CloseButtonProps,
  ToastContainer,
} from 'shared/lib/external/ReactToastify';

import { IconWrapper } from '../IconWrapper';
import { Portal } from '../Portal';
import cls from './NotificationsContainer.module.scss';

/** Кнопка закрытия тоста */
const CloseButton = ({ closeToast }: CloseButtonProps) => (
  <Stack className={cls.CloseButton} onClick={closeToast}>
    <IconWrapper icon={Close} />
  </Stack>
);

/** Контейнер для вывода уведомлений */
export const NotificationsContainer = () => {
  return Portal({
    children: (
      <ToastContainer
        className={cls.Toastify}
        autoClose={7000}
        draggable
        draggablePercent={60}
        toastClassName={cls.Toast}
        progressClassName={cls.Progress}
        closeButton={CloseButton}
        position='bottom-right'
      />
    ),
    container: document.body,
  });
};
